interface SavedCampaignComparison {
  benchmarkCampaign: string | null
  selectedCampaigns: Array<{
    id: string
    name: string
  }>
}

const CAMPAIGN_COMPARISON_KEY = 'campaign_comparison'

export const saveCampaignComparison = (data: SavedCampaignComparison): void => {
  try {
    localStorage.setItem(CAMPAIGN_COMPARISON_KEY, JSON.stringify(data))
  } catch (error) {
    console.error('Failed to save campaign comparison:', error)
  }
}

export const getCampaignComparison = (): SavedCampaignComparison | null => {
  try {
    const saved = localStorage.getItem(CAMPAIGN_COMPARISON_KEY)
    return saved ? JSON.parse(saved) : null
  } catch (error) {
    console.error('Failed to get campaign comparison:', error)
    return null
  }
}

export const clearCampaignComparison = (): void => {
  try {
    localStorage.removeItem(CAMPAIGN_COMPARISON_KEY)
  } catch (error) {
    console.error('Failed to clear campaign comparison:', error)
  }
}
